import { render, staticRenderFns } from "./PersonLimit.vue?vue&type=template&id=4c32282c&"
import script from "./PersonLimit.vue?vue&type=script&lang=js&"
export * from "./PersonLimit.vue?vue&type=script&lang=js&"
import style0 from "./PersonLimit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports